import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { SectionHeader } from '../SectionHeader';
import { CtaButton } from '../CtaButton';
import { bonuses } from '../../data/bonuses';
export function BonusesSection() {
  return <section className="w-full bg-navy-900 px-5 py-16 sm:py-24" data-id="element-95" data-mp="qeaeqi86f41q">
      <SectionHeader tone="dark" eyebrow="Your complete clinical resource collection" title="The Six Volumes Are Just the Beginning" lead="I also included five practical resources designed to complement the main collection." data-id="element-96" data-mp="vb0sgywidnjz" />

      <div className="mx-auto mt-14 max-w-6xl space-y-16 sm:space-y-20" data-id="element-97" data-mp="19blavtyihhcy">
        {bonuses.map((b, i) => <article key={b.number} className="grid items-center gap-8 lg:grid-cols-2 lg:gap-14" data-id="element-98" data-mp="1eaeodmdst8d4" data-mpi={i}>
            <div className={`-mx-5 bg-white sm:mx-0 sm:rounded-3xl ${i % 2 === 1 ? 'lg:order-2' : ''}`} data-id="element-99" data-mp="220isduuwfa4n">
              <img src={b.image} alt={`Bonus ${b.number}: ${b.title}`} className="block w-full" loading="lazy" data-id="element-100" data-mp="26qpgltli0smd" />
            </div>

            <div data-id="element-101" data-mp="2m6jylehxia3w">
              <span className="inline-flex items-center gap-2 rounded-lg px-3 py-1.5 font-display text-xl font-black uppercase tracking-wide text-white" style={{
            backgroundColor: b.color
          }} data-id="element-102" data-mp="2m60lqc74ybwq">
                <GiftIcon className="h-5 w-5" aria-hidden="true" data-id="element-103" data-mp="2r4lhnzfcu9fd" />
                Bonus {b.number}
              </span>
              <h3 className="mt-4 font-display text-3xl font-extrabold uppercase leading-tight text-white sm:text-4xl" data-id="element-104" data-mp="34v75m2jo19k4">{b.title}</h3>
              <p className="mt-3 text-lg leading-relaxed text-slate-300" data-id="element-105" data-mp="2zwdp019312fq">{b.description}</p>

              <p className="mt-6 font-display text-lg font-bold uppercase tracking-wide text-brand" data-id="element-106" data-mp="3esuy0ltsu4z4">{b.listLabel}</p>
              <ul className="mt-3 space-y-2.5" data-id="element-107" data-mp="39vuscc0v348j">
                {b.items.map(item => <li key={item} className="flex items-start gap-2.5 text-base leading-snug text-slate-100" data-id="element-108" data-mp="1kgomflwztm6a">
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" strokeWidth={3} aria-hidden="true" data-id="element-109" data-mp="1fj50dzu2053s" />
                    {item}
                  </li>)}
              </ul>
              <p className="mt-5 border-l-2 border-white/20 pl-4 text-sm italic leading-relaxed text-slate-400" data-id="element-110" data-mp="298vnq49vd9kw">{b.note}</p>
            </div>
          </article>)}
      </div>

      <div className="mx-auto mt-20 max-w-3xl text-center" data-id="element-111" data-mp="2j6jujskr27jf">
        <h3 className="text-balance font-display text-3xl font-extrabold uppercase leading-tight text-white sm:text-4xl" data-id="element-112" data-mp="2o4lf6hxtqex0">
          A More Organized Approach to the Low Back Pain Cases You Encounter
        </h3>
        <div className="mt-5 space-y-4 text-lg leading-relaxed text-slate-300" data-id="element-113" data-mp="2ww3vqtyomwqm">
          <p data-id="element-114" data-mp="31vzxemjwqc30">
            Whether you’re reviewing a patient with localized lumbar discomfort, symptoms extending into the leg, recurrent episodes, or an
            unfamiliar presentation, this collection provides educational references designed to help organize your assessment process.
          </p>
          <p data-id="element-115" data-mp="106u4k2oydm5x">
            You’ll have a framework for the initial interview, a dedicated screening guide, an examination reference, clinical reasoning
            resources, and educational cases.
          </p>
          <p data-id="element-116" data-mp="q7bnbu0fgehk">
            The purpose isn’t to make every patient fit the same pathway. It’s to help you approach each assessment with a clearer process while
            remaining attentive to individual presentation, clinical uncertainty, professional scope, and the need for additional evaluation
            when appropriate.
          </p>
        </div>
      </div>

      <CtaButton tone="dark" label="Get All 6 Volumes + 5 Bonuses" sub="One-time payment of $27 · Instant access · 7-day guarantee" data-id="element-117" data-mp="196z79zj7bwdr" />
    </section>;
}